import { IThemeRGB } from "../../types";

export const tailwindColorTheme: IThemeRGB = {
  "rgb-primary": "24, 51, 98", // ocean-700
  "rgb-acc-1": "255, 130, 15", // orange-400
  "rgb-background-acc-1": "43, 93, 182", // sky-600
  "rgb-background-acc-start": "43, 93, 182", // sky-600
  "rgb-button-1": "61, 145, 240", // sky-400
  "rgb-link-1": "61, 145, 240", // sky-400
  "rgb-button-2": "39, 105, 180", // sky-600
  "rgb-link-2": "39, 105, 180", // sky-600
  "rgb-link-light": "109, 176, 252", // sky-300
  "rgb-code-background": "24, 51, 98", // ocean-700
};
